import React from "react";
import { useNavigate } from "react-router-dom";
import "./TrialBanner.css";
import { BsStars } from "react-icons/bs";
const TrialBanner = ({ user, onClose }) => {
  const navigate = useNavigate();

  const plan = user?.plan;
  const expiryDate = plan?.expiry_date;
  const amount = Number(plan?.amount ?? 0);

  if (!user) {
    return null;
  }

  if (!expiryDate) {
    return null;
  }

  if (amount > 0) {
    return null;
  }

  const expiry = new Date(expiryDate);

  console.log("8. Parsed expiry date:", expiry);
  console.log("9. Is expiry date valid:", !Number.isNaN(expiry.getTime()));

  if (Number.isNaN(expiry.getTime())) {
    return null;
  }

  const millisecondsPerDay = 1000 * 60 * 60 * 24;

  const daysRemaining = Math.max(
    0,
    Math.ceil((expiry.getTime() - Date.now()) / millisecondsPerDay),
  );

  const trialExpired = Boolean(plan?.is_expired) || daysRemaining === 0;

  console.log("10. Days remaining:", daysRemaining);
  console.log("11. Trial expired:", trialExpired);
  console.log("12. Rendering banner now");

  return (
    <div className="trial-banner" role="status">
      <div className="trial-banner-message">
        <span className="trial-banner-icon" aria-hidden="true">
          ⓘ
        </span>

        <span>
          {trialExpired ? (
            "Your free trial has expired. Upgrade to keep all features."
          ) : (
            <>
              You have <strong>{daysRemaining} days</strong> left in your free
              trial. Upgrade to keep all features.
            </>
          )}
        </span>
      </div>

      <div className="trial-banner-actions">
        <button
          type="button"
          className="trial-upgrade-button"
          onClick={() => navigate("/pricing")}
        >
          <BsStars />
          Upgrade Now
        </button>
      </div>
    </div>
  );
};

export default TrialBanner;
